export default ($stateProvider) => {
  $stateProvider
    .state('browser-support-msg', {
      url: `${location.pathname}browser-support-error`,
      template: '<nets-browser-support-msg></nets-browser-support-msg>',
    });
};
